// Flag state options. `letterhead` (optional) — if set, the certificate is rendered on top of
// a pre-designed letterhead image (header/footer/stamp baked in). Otherwise we render our
// own header + footer using `emblem` + `authority`.
export const FLAG_STATES = [
  {
    name: "Republic of Zambia",
    letterhead: "/letterheads/zambia_hd.png",
    authority: "Zambia Maritime Administration",
    domain: "www.zambshipadmin.org",
    hasBuiltInFooter: true, // signature + stamp already in image
  },
  {
    name: "St. Kitts & Nevis",
    letterhead: "/letterheads/skan_hd.png",
    authority: "St. Kitts & Nevis International Ship Registry",
    domain: "Department of Maritime Affairs",
    hasBuiltInFooter: false, // we render our own signature/stamp on top
  },
  {
    name: "St. Maarten Islands",
    emblem:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Coat_of_arms_of_Sint_Maarten.svg/240px-Coat_of_arms_of_Sint_Maarten.svg.png",
    authority: "St. Maarten Islands Maritime Administration",
    domain: "www.msta-registry.com/Certification@msta-registry.com",
  },
  {
    name: "Republic of Panama",
    emblem:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Coat_of_arms_of_Panama.svg/240px-Coat_of_arms_of_Panama.svg.png",
    authority: "Panama Maritime Authority",
    domain: "www.amp.gob.pa",
  },
  {
    name: "Republic of Liberia",
    emblem:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Coat_of_arms_of_Liberia.svg/240px-Coat_of_arms_of_Liberia.svg.png",
    authority: "Liberian Registry",
    domain: "www.liscr.com",
  },
  {
    name: "Marshall Islands",
    emblem:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Seal_of_the_Marshall_Islands.svg/240px-Seal_of_the_Marshall_Islands.svg.png",
    authority: "Republic of the Marshall Islands Maritime Administrator",
    domain: "www.register-iri.com",
  },
  {
    name: "Republic of Honduras",
    emblem:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Coat_of_arms_of_Honduras.svg/240px-Coat_of_arms_of_Honduras.svg.png",
    authority: "Honduras Maritime Administration",
    domain: "www.dgmm.hn",
  },
  {
    name: "Cook Islands",
    emblem:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Coat_of_arms_of_the_Cook_Islands.svg/240px-Coat_of_arms_of_the_Cook_Islands.svg.png",
    authority: "Maritime Cook Islands",
    domain: "www.maritimecookislands.com",
  },
];

export function getFlagState(name) {
  return FLAG_STATES.find((f) => f.name === name) || FLAG_STATES[0];
}
